import { Component, EventEmitter, Input, Output } from '@angular/core';
import { isArray, isEmpty, remove } from 'lodash';
import {
  ReportTemplateFieldCategory,
  ReportTemplateFieldDefinition,
  ReportTemplateFieldType,
} from 'src/dto/report-template';
import { MatList, MatListItem } from '@angular/material/list';
import { CdkDropList, CdkDrag, CdkDragPreview, CdkDragPlaceholder } from '@angular/cdk/drag-drop';
import { ButtonV2Module } from '@schenck/rotec-components';
import { SlicePipe } from '@angular/common';
import { TemplateToolboxItemFreetextComponent } from '../template-toolbox-item-freetext/template-toolbox-item-freetext.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'rc-template-toolbox-category-freetext',
  templateUrl: './template-toolbox-category-freetext.component.html',
  styleUrls: ['./template-toolbox-category-freetext.component.less'],
  imports: [
    MatList,
    CdkDropList,
    MatListItem,
    ButtonV2Module,
    CdkDrag,
    TemplateToolboxItemFreetextComponent,
    CdkDragPreview,
    CdkDragPlaceholder,
    SlicePipe,
    TranslatePipe
],
})
export class TemplateToolboxCategoryFreetextComponent {
  @Input() name: string;
  @Input() userDefinedFields: ReportTemplateFieldDefinition[];
  @Output() userDefinedFieldsChange: EventEmitter<ReportTemplateFieldDefinition[]>;

  constructor() {
    this.userDefinedFieldsChange = new EventEmitter<ReportTemplateFieldDefinition[]>();
  }

  preventDrop(): boolean {
    return false;
  }

  addField(): void {
    if (!isArray(this.userDefinedFields)) {
      this.userDefinedFields = [];
    }

    this.userDefinedFields.push({
      name: `freetext${this.userDefinedFields.length + 1}`,
      category: ReportTemplateFieldCategory.Miscellaneous,
      type: ReportTemplateFieldType.String,
      value: '',
    } as ReportTemplateFieldDefinition);
  }

  removeField(userDefinedField: ReportTemplateFieldDefinition): void {
    if (userDefinedField && !isEmpty(this.userDefinedFields)) {
      const removedFields = remove(this.userDefinedFields, (x) => x.name === userDefinedField.name);
      if (!isEmpty(removedFields)) {
        this.userDefinedFieldsChange.emit(this.userDefinedFields);
      }
    }
  }
}
